import React from "react";
import MahingaHeader from "./MahingaHeader";
import MahingaSections from "./MahingaSections";

const Mahinga = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <MahingaHeader />
      <MahingaSections />
    </div>
  );
};

export default Mahinga;
